import boFetch from './request';
import {toQueryString} from './filterExpression';
import {crudMethods} from './../consts';

const isValidString = (input) => (typeof(input) === 'string' && input.length);

const isValidNumber = (input) => (typeof(input) === 'number' && String(input).match(/^\d+$/));

const isValidBoolean = (input) => (typeof(input) === 'boolean');

const isFunction = (fn) => (!!(fn && typeof(fn) === 'function'));

// [options]:
// {
//     type: 'account',
//     params: {
//         layout: ['name', 'description'],
//         orderBy: ['id:DESC', 'name:ASC'],
//         filter: {
//              operator: 'or',
//              value: [
//                  {operator: 'eq', property: 'id', value: 10001},
//                  {operator: 'eq', property: 'id', value: 10002}
//              ]
//         },
//         limit: 250,
//         offset: 0
//     },
//     // For methods [post, put, delete]
//     data: {
//         entities: [
//             {id, type, ...},
//             ...
//         ]
//     }
//     cancelToken: (cancelFunc){}
// }

// [callbacks]:
// {
//     start: fn(){},
//     success: fn(json){},
//     fail: fn(e){}
// }

const entityFetcher = Object.entries(crudMethods).reduce((p, n) => (Object.assign(p, {
    [n[0]](options = {}, callbacks = {}) {
        isFunction(callbacks.start) && callbacks.start();
        return boFetch({
            method: n[1].toLowerCase(),
            url: options.fullUrl || `/bo/rest/entities/${options.api}`,
            params: options.params || {},
            data: options.data || {},
            ...(options.cancelToken ? {cancelToken: options.cancelToken} : {}),
            paramsSerializer: (params) => {
                let stringifyParams = [], filterQueryString = '';
                Object.keys(params).forEach((key) => {
                    (isValidString(params[key]) || isValidNumber(params[key]) || isValidBoolean(params[key]) || (Array.isArray(params[key]) && params[key].length)) && (() => {
                        stringifyParams.push(`${encodeURIComponent(String(key))}=${encodeURIComponent(String(params[key]))}`);
                    })();
                    if (key === 'filter') {
                        filterQueryString = toQueryString(params[key] || {});
                        filterQueryString && stringifyParams.push(`${encodeURIComponent(String(key))}=${encodeURIComponent(filterQueryString)}`);
                    }
                });
                return stringifyParams.join('&');
            },
        }).then(
            json => {
                isFunction(callbacks.success) && callbacks.success(json);
                return json;
            },
            e => {
                isFunction(callbacks.fail) && callbacks.fail(e);
                return Promise.reject(e);
            }
        );
    }
})), {});

export {entityFetcher}


// WEBPACK FOOTER //
// ./src/app/utils/entityFetcher.js